import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { MatSidenav } from '@angular/material';

/**
 * A Subject is like an Observable, but can multicast to many Observers.
 * Subjects are like EventEmitters: they maintain a registry of many listeners.
 */

@Injectable({
  providedIn: 'root'
})

export class ComponentInteractionService {
    private sidenav: MatSidenav;
    private listeners = new Subject <any>();

    invokeEvent: Subject<any> = new Subject();

    listen(): Observable<any> {
      return this.listeners.asObservable();
    }


    public setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
    }

    public open() {
        return this.sidenav.open();
    }


    public close() {
        return this.sidenav.close();
    }

    public toggle(): void {
      this.sidenav.toggle();
    }


  constructor() { }
}
